import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { isStaffUser, formatDate, createRowSelector, useTerminology } from "utils";
import { CrudOptions, Lookup } from "frame/components";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		position: "relative",
		marginBottom: theme.spacing(2),
		"&:hover": {
			cursor: "pointer",
		},
	},
	container: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(2),
		flexGrow: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			flexWrap: "wrap",
		},
		"&:last-child": {
			paddingBottom: theme.spacing(3),
		},
	},
	subHeading: {
		marginTop: theme.spacing(2),
		fontWeight: "bold",
	},
	label: {
		color: "#999999",
	},
}));

const SafetyPlanChecklistCard = ({
	safetyPlanChecklist,
	onView,
	onEdit,
	onClone,
	onDelete,
	role,
	onEmail,
}) => {
	const classes = useStyles();
	const { siteLabel } = useTerminology();
	const onRowSelect = createRowSelector(onView);
	const id = {
		id: safetyPlanChecklist.id,
		form: "safety-plan-checklist",
	};

	const attachmentCount =
		(safetyPlanChecklist.attachments?.length || 0) +
		(safetyPlanChecklist.notifiableWorksAttachments?.length || 0) +
		(safetyPlanChecklist.emergencyPlanAttachments?.length || 0);

	return (
		<Card className={classes.root} onClick={onRowSelect}>
			<CardContent className={classes.content}>
				<Grid className={classes.container} container spacing={2}>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Name
						</Typography>
						<Typography variant="h5">
							{safetyPlanChecklist.name || "-"}
						</Typography>
					</Grid>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							{siteLabel} Name
						</Typography>
						<Typography variant="h5">
							<Lookup
								id={safetyPlanChecklist.siteId}
								resource="sites"
								attribute="siteName"
							/>
						</Typography>
					</Grid>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Created
						</Typography>
						<Typography variant="h5">
							{formatDate(safetyPlanChecklist.createdAt)}
						</Typography>
					</Grid>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Attachments
						</Typography>
						<Typography variant="h5">
							{attachmentCount}
						</Typography>
					</Grid>
					<div className="ignore">
						{!isStaffUser(role) && (
							<CrudOptions
								onView={onView}
								onEdit={onEdit}
								onClone={onClone}
								onDelete={() => onDelete(id)}
								onEmail={onEmail}
							/>
						)}
					</div>
				</Grid>
			</CardContent>
		</Card>
	);
};

SafetyPlanChecklistCard.propTypes = {
	safetyPlanChecklist: PropTypes.object.isRequired,
	onView: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,
	onClone: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	role: PropTypes.string.isRequired,
	onEmail: PropTypes.func.isRequired,
};

export default SafetyPlanChecklistCard;
